import { FORM_CONFIG } from './formConfig';
import i18next from 'i18next';
import * as Yup from 'yup';
import { CartridgeInfoType } from './Pages/SetCartridgeType/setCartridgeType';

export const getValidationSchema = (step: number, cartridge: CartridgeInfoType, deployedSupply: number, t: any) => {
	switch (step) {
		case 2:
			return Yup.object().shape({
				tags: Yup.array().required().min(1),
			});
		case 3:
			return Yup.object().shape({
				platforms: Yup.array().required().min(1),
			});
		case 4:
			return Yup.object().shape({
				/*totalSupply: Yup.number()
					.typeError(t('form.validation.mustBeNumber'))
					.required(t('form.validation.required'))
					.min(0, i18next.t('form.validation.minIs', { number: 0 }))
					.max(cartridge.maxSupply, i18next.t('form.validation.maxIs', { number: cartridge.maxSupply }))
					.integer(t('form.validation.integer')),
				gameTitle: Yup.string().required(t('form.validation.required')),
				feePercent: Yup.number()
					.typeError(t('form.validation.mustBeNumber'))
					.min(0, i18next.t('form.validation.minIs', { number: 0 }))
					.max(99.9, i18next.t('form.validation.maxIs', { number: cartridge.maxFee }))
					.required(t('form.validation.required')),
				abbreviation: Yup.string()
					.max(FORM_CONFIG.MAX_SYMBOL_LENGTH, t('form.validation.tooLong'))
					.required(t('form.validation.required')),*/
				media: Yup.object().shape({
					/*logoUrl: Yup.string()
						.url(t('form.validation.image'))
						.required(i18next.t('form.validation.required')),*/
					cover: Yup.string()
						.url(t('form.validation.image'))
						.required(i18next.t('form.validation.required')) /*
					banner: Yup.string()
						.url(t('form.validation.image'))
						.required(i18next.t('form.validation.required')),*/,
				}),
				/*
				colors: Yup.object().shape({
					actionColor: Yup.string()
						.matches(/^#[a-f0-9]{6}$/i, i18next.t('form.validation.hex'))
						.required(i18next.t('form.validation.required')),
					textColor: Yup.string()
						.matches(/^#[a-f0-9]{6}$/i, i18next.t('form.validation.hex'))
						.required(i18next.t('form.validation.required')),
					backgroundColor: Yup.string()
						.matches(/^#[a-f0-9]{6}$/i, i18next.t('form.validation.hex'))
						.required(i18next.t('form.validation.required')),
				}),*/
			});
		case 5:
			return Yup.object().shape({
				name: Yup.string().required(t('form.validation.required')).min(3,'form.validation.tooShort'),
				symbol: Yup.string()
					.max(FORM_CONFIG.MAX_SYMBOL_LENGTH, t('form.validation.tooLong'))
					.required(i18next.t('form.validation.required')).min(2, i18next.t('form.validation.tooShort')),
			});
		case 6:
			return Yup.object().shape({
				gameUrl: Yup.string().url(i18next.t('form.validation.url')).required(i18next.t('form.validation.required')),
			});
		case 7:
			return Yup.object().shape({
				media: Yup.object().shape({
					logoUrl: Yup.string().url(i18next.t('form.validation.image')).required(i18next.t('form.validation.required')),
				}),
			});
		case 22:
			return Yup.object().shape({
				description: Yup.string().required(i18next.t('form.validation.required')),
				socials: Yup.object().shape({
					facebook: Yup.string().url(i18next.t('form.validation.url')),
					twitter: Yup.string().url(i18next.t('form.validation.url')),
					youtube: Yup.string().url(i18next.t('form.validation.url')),
					discord: Yup.string().url(i18next.t('form.validation.url')),
				}),
				video: Yup.string().url(i18next.t('form.validation.youtubeUrl')),
				gamepaper: Yup.string().url(i18next.t('form.validation.url')).required(i18next.t('form.validation.required')),
			});
		case 4:
			return Yup.object().shape({
				igoSupply: Yup.number()
					.typeError(t('form.validation.mustBeNumber'))
					.required(t('form.validation.required'))
					.min(0, i18next.t('form.validation.minIs', { number: 0 }))
					.max(deployedSupply, i18next.t('form.validation.maxIs', { number: deployedSupply }))
					.integer(t('form.validation.integer')),
				unitPrice: Yup.number()
					.test(
						'len',
						t('form.validation.twoDecimals'),
						number =>
							(String(number).length <= 4 && String(number).includes('.')) ||
							!String(number).includes('.')
					)
					.typeError(t('form.validation.mustBeNumber'))
					.required(t('form.validation.required'))
					.min(0.01, i18next.t('form.validation.minIs', { number: 0.01 })),
			});
		case 5:
			return Yup.object().shape({}); /*
			return Yup.object().shape({
				email: Yup.string().email(i18next.t('form.validation.email')).required(t('form.validation.required')),
			});*/
		default:
			return Yup.object().shape({});
	}
};
